export default "__VITE_ASSET__DWXPK0GO__"